import React, { Component} from 'react';
import { Toast } from 'react-bootstrap';


export class CustomToast extends Component {


    constructor(props) {
        super(props);


        this.state = { isHidden: false };
        this.hideToast = this.hideToast.bind(this);

    }



    hideToast() {

        this.setState({ isHidden: true });

    }

    render() {

        return (

            <Toast className="shadow-sm mt-2 ms-2 me-2 mb-0 invisible" show={!this.state.isHidden} onClose={this.hideToast}>
                <Toast.Header className="py-1 px-3">
                    <strong className="me-auto">Uwaga</strong>
                    <small className="text-muted">04.04.2022 13:50</small>
                </Toast.Header>
                <Toast.Body className="toast-body-font">Awizacja AW/2022/12/01/0001 została anluowana.</Toast.Body>
            </Toast>

        );
    }
}
